import { jwtDecode } from 'jwt-decode';

interface JwtPayload {
  exp: number;
  [key: string]: any;
}

const getApiBaseURL = () => {
  if (import.meta.env.PROD) {
    return import.meta.env.VITE_API_BASE_URL || window.location.origin;
  }
  return import.meta.env.VITE_API_BASE_URL || 'http://localhost:5244';
};


export function isAccessTokenValid(): boolean {
  const token = localStorage.getItem('accessToken');
  if (!token) return false;

  try {
    const decoded = jwtDecode<JwtPayload>(token);
    const currentTime = Date.now() / 1000;
    return decoded.exp > (currentTime + 30);
  } catch (error) {
    console.error('Error decoding token:', error);
    return false;
  }
}

export async function tryRefreshToken(): Promise<boolean> {
  const refreshToken = localStorage.getItem('refreshToken');
  if (!refreshToken) return false;

  try {
    const response = await fetch(`${getApiBaseURL()}/api/auth/refresh-token`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        accessToken: localStorage.getItem('accessToken'),
        refreshToken: refreshToken,
      }),
    });

    if (!response.ok) {
      throw new Error('Refresh failed');
    }

    const data = await response.json();
    localStorage.setItem('accessToken', data.accessToken);
    localStorage.setItem('refreshToken', data.refreshToken);

    return true;
  } catch (error) {
    console.error('Refresh token failed:', error);
    localStorage.removeItem('accessToken');
    localStorage.removeItem('refreshToken');
    return false;
  }
}

export async function ensureValidAccessToken(): Promise<boolean> {
  if (isAccessTokenValid()) return true;
  return await tryRefreshToken();
}
